/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { getToApi } from "venuescanner-js/services/api";
import { $, pageLoaded } from "venuescanner-js/tools/elemental";
// eslint-disable-next-line no-unused-vars
import { node, jsxWatch } from "venuescanner-js/tools/jsx";
import {
  INTEGER,
  STRING,
} from "venuescanner-js/vanilla/models/ObservablePropTypes";
const urls = {
  inbox: "user/threads/unread",
};
const count = new INTEGER(null, 0);
const displayCounter = new STRING(null, count.valueOf() > 0 ? "block" : "none");
const displayNumber = new STRING(
  null,
  count.valueOf() > 9 ? "9+" : count.toString()
);

const params = window.location.pathname.replace(/^\//, "").split("/");
const isInbox = params[0] === "inbox";

const Counter = () =>
  isInbox ? null : (
    <span
      class="ux-navbar-new-msg"
      style={{
        display: displayCounter,
      }}
    >
      {displayNumber}
    </span>
  );

count.watch(() => {
  displayCounter.set(count.valueOf() > 0 ? "block" : "none");
  displayNumber.set(count.valueOf() > 9 ? "9+" : count.toString());
});

export const unread = {
  initialised: false,
  init: function () {
    if (!window.data || !window.data.viewerToken) return;
    if (this.initialised) return this.fetch();
    this.initialised = true;
    // const inboxNavMobile = $('.ux-navbar-item.my-inbox').get(0)
    const inboxNav = $(".ux-navbar-right .ux-navbar-item.my-inbox");
    const mobileMenu = $(".ux-burger-menu");
    if (inboxNav.get(0)) {
      const counter = <Counter />;
      inboxNav.append(counter);
      if (mobileMenu.get(0)) mobileMenu.append(counter);
      this.fetch();
    }
  },
  fetch: async function () {
    const response = await getToApi(urls.inbox);
    if (response.unread) {
      count.set(response.unread);
    } else {
      count.set(0);
    }
  },
  decrement: async function () {
    count.decrement();
  },
};

window.unread = unread;
// pageLoaded(() => {
//   unread.init()
// })
